module.exports = __webpack_public_path__ + "img/pcc.487fc21d.png";